import gql from 'graphql-tag'

export const ProfilesGQL = {
    ALL_PROFILES: gql`query AllProfiles{profiles{
        id
        profileName
        description
        region
    }}`,

    CREATE_PROFILE: gql`
        mutation CreateProfile(
            $profileName: String!,
            $description: String,
            $accessKeyId: String!,
            $secretAccessKey: String!,
            $region: String!
        ){
            createProfile(
                profileName: $profileName,
                description: $description,
                accessKeyId: $accessKeyId,
                secretAccessKey: $secretAccessKey,
                region: $region
            ){id}}`,

    DELETE_PROFILE: gql`
        mutation DeleteProfile($profileId: ID!){
            deleteProfile(profileId: $profileId){id}
        }
    `
}
